import { useState } from 'react';

import { useQueryClient } from 'react-query';

import { DEFAULT_ERROR, useCustomSnackBar } from 'hooks/useCustomSnackBar';

import { useProjectTreeStore } from 'store/projectContract.store';

import { useMutationDeleteStoredFilterBulkAssignToUser } from 'api/mutations/deleteStoredFilterBulkAssignToUser.mutation';

import { MuiIcon } from 'components/common/Icons/base/MuiIcon/MuiIcon';

import { CustomizedConfirmDeleteModal, CustomizedRoundIcon } from 'components/common';

export const DeleteBulkAssignToUserCell = ({ row }) => {
    const [show, setShow] = useState<boolean>(false);
    const { contract } = useProjectTreeStore();
    const { handleSnackBar } = useCustomSnackBar();
    const queryClient = useQueryClient();

    const { mutate } = useMutationDeleteStoredFilterBulkAssignToUser();

    const handleDelete = () => {
        if (!contract) return null;
        mutate(
            {
                contractId: contract.id,
                id: row.id,
            },
            {
                onSuccess: () => {
                    handleSnackBar('Successfully deleted!', 'success');
                },
                onError: (error) => {
                    DEFAULT_ERROR({ error, handleError: handleSnackBar });
                },
                onSettled: () => {
                    queryClient.invalidateQueries('getStoredFilterBulkAssignToUser');
                },
            },
        );
        setShow(false);
    };

    return (
        <div>
            <CustomizedRoundIcon onClick={() => setShow(true)}>
                <MuiIcon icon={'delete'} type={'outlined'} />
            </CustomizedRoundIcon>
            <CustomizedConfirmDeleteModal
                isShowModal={show}
                hideModal={() => setShow(false)}
                text={`Are you sure you want to delete this rule?`}
                onConfirm={handleDelete}
            />
        </div>
    );
};
